import './darkerTheme.scss';

const DarkerTheme = () => <></>;

export default DarkerTheme;
